/**
 * Registered in docs/Framework_Catalogs/Analytics_Master_Schema.md (Water
 * Sort section). This module owns no analytics SDK integration — it's a
 * typed constants surface over the platform's stubbed `IAnalyticsService`
 * (see events.ts for each event's property shape).
 *
 * 9 events, not the 7 this WP's own plan originally named: the master
 * schema also defines `watersort_invalid_move` (Move Interaction section)
 * and `watersort_reward_granted` (Rewards section) as real catalog events,
 * and store/waterSortStore.ts already fires both from the correct action
 * (attemptMove's failure path, _awardLevelCompleteRewards) — kept rather
 * than trimmed to match the plan's original count.
 */
export const WATERSORT_ANALYTICS_EVENTS = {
    LEVEL_STARTED: 'watersort_level_started',
    LEVEL_COMPLETED: 'watersort_level_completed',
    MOVE_MADE: 'watersort_move_made',
    INVALID_MOVE: 'watersort_invalid_move',
    UNDO_USED: 'watersort_undo_used',
    RESET_USED: 'watersort_reset_used',
    HINT_USED: 'watersort_hint_used',
    EXTRA_TUBE_USED: 'watersort_extra_tube_used',
    REWARD_GRANTED: 'watersort_reward_granted',
};
